import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../constants';

export const jwtInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const access_token = Constants.ACCESS_TOKEN()?.replaceAll('"', '');
  const isTokenRequired = request.context.get(Constants.TOKEN_REQUIRED);
  if (access_token && isTokenRequired) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  return next(request);
};
